module.exports = __webpack_public_path__ + "img/Ramaswamy.b155e7de.png";